import { useQuery } from 'react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import type { PlanEntity } from '../services/api/plan/interfaces';
import type { PlanRepository } from '../services/api/plan/PlanRepository';

export const planQueryConfig = (accountId: number, planRepository: PlanRepository) =>
  ({
    queryKey: QueryKeys.getAccountPlan(accountId),
    queryFn: () => planRepository.getAccountPlan(accountId),
    staleTime: 0,
    refetchOnWindowFocus: true,
  } satisfies UseQueryOptions);

type UsePlanApiDataParams = {
  planRepository: PlanRepository;
  accountId: number;
  enabled?: boolean;
  refetchOnMount?: boolean;
  refetchOnWindowFocus?: boolean;
};

type UsePlanApiDataResult = {
  planData?: PlanEntity;
  isLoading: boolean;
  isError: boolean;
  isFetched: boolean;
};

type UsePlanApiData<P> = (params: P) => UsePlanApiDataResult;

export const usePlanApiData: UsePlanApiData<UsePlanApiDataParams> = ({
  planRepository,
  accountId,
  enabled = true,
  refetchOnMount = true,
  refetchOnWindowFocus = true,
}) => {
  const { data, isLoading, isError, isFetched } = useQuery({
    ...planQueryConfig(accountId, planRepository),
    enabled,
    refetchOnMount,
    refetchOnWindowFocus,
  });

  return {
    planData: data,
    isLoading,
    isError,
    isFetched,
  };
};
